import { startLoading, endLoading } from './app-dux';
import { fetchGql } from '../utils/fetch-gql';
import format from 'date-fns/format';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    showConfirmationModal: false
};

/*******************************************************************************
 * Non-async action types
 */
export const DOWNLOAD_COMPLETE = 'DOWNLOAD_COMPLETE';
export const CLEAR_CONFIRMATION_MODAL = 'CLEAR_CONFIRMATION_MODAL';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {

    switch ( action.type ) {
        case DOWNLOAD_COMPLETE: {
            return {
                ...state,
                showConfirmationModal: true
            };
        }
        case CLEAR_CONFIRMATION_MODAL: {
            return {
                ...state,
                showConfirmationModal: false
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export const exportContent = ( type, projects ) => async ( dispatch, getState ) => {
    const gqlQuery = `query ( $projects: [ String ], $locales: [ String ], $keys: [ String ], $withoutFallbacks: Boolean! ){
                        exportContent( projects: $projects, locales: $locales, keys: $keys, withoutFallbacks: $withoutFallbacks ) {
                            dataUrl
                        }
                    }`;
    const variables = {
        projects,
        keys: [],
        locales: [],
        withoutFallbacks: true
    };

    try {
        dispatch( startLoading() );

        const { data, errors } = await fetchGql( gqlQuery, variables );

        if ( errors ) {
            throw new Error( errors );
        }
        
        if ( data.exportContent.dataUrl ) {
            dispatch( download( `cmx-content_${ format( new Date(), 'yyyy-mm-ddTHH:mm:ss' ) }.json`, data.exportContent.dataUrl ) );
        }
        return data;
    } catch ( err ) {
        console.error( 'Error while trying to export content:', err );
        throw new Error( err );
    } finally {
        dispatch( endLoading() );
    }
};

function download( filename, dataUrl ) {
    if ( navigator.msSaveBlob ) {
        const blob = dataURItoBlob( dataUrl );
        navigator.msSaveBlob( blob, filename );
    } else {
        const objectUrl = URL.createObjectURL( dataURItoBlob( dataUrl ) );
        const element = document.createElement( 'a' );

        element.setAttribute( 'href', objectUrl );
        element.setAttribute( 'download', filename );

        element.style.display = 'none';

        document.body.appendChild( element );

        element.click();

        document.body.removeChild( element );
    }
    return {
        type: DOWNLOAD_COMPLETE
    };
}

function dataURItoBlob( dataURI ) {
    const mime = dataURI.split( ',' )[ 0 ].split( ':' )[ 1 ].split( ';' )[ 0 ];
    const binary = atob( dataURI.split( ',' )[ 1 ] );
    const array = [];
    for ( let i = 0; i < binary.length; i++ ) {
        array.push( binary.charCodeAt( i ) );
    }
    return new Blob( [ new Uint8Array( array ) ], { type: mime } );
}

export const clearConfirmationModal = ( ) => ( { type: CLEAR_CONFIRMATION_MODAL } );